require('./js/date-formatter');
require('./js/date-parser');
require('./js/debounce');
require('./js/dimensions');
require('./js/parse-options');
require('./js/raf');

angular.module('ui-ng-core-bootstrap', [
  'mgcrea.ngStrap.helpers.dateFormatter',
  'mgcrea.ngStrap.helpers.dateParser',
  'mgcrea.ngStrap.helpers.debounce',
  'mgcrea.ngStrap.helpers.dimensions',
  'mgcrea.ngStrap.helpers.parseOptions'
]);



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-core-bootstrap/src/main.js